import { api } from './index';

const BASE_PATH = '/api/internal/announcements';

export type AnnouncementCategory = 'feature' | 'improvement' | 'fix';

export interface Announcement {
  id: number;
  title: string;
  body: string;
  category: AnnouncementCategory;
  humanCategory: string;
  imageUrl: string | null;
  publishedAt: string | null;
  humanPublishedAt: string | null;
}

export interface AnnouncementsResponse {
  announcements: Announcement[];
  meta: {
    unreadCount: number;
  };
}

export const announcementsApi = {
  index(): Promise<AnnouncementsResponse> {
    return api({
      method: 'get',
      url: BASE_PATH,
    }).then(response => response.data);
  },
};
